module.exports = __webpack_public_path__ + "img/ExpandMore1.c78e7bd6.svg";